export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.questionCategories = payload;

  return newState;
};
